import React, { useEffect, useState } from "react";
import "../Styles/AdminDashboard.css"; // External CSS for custom styles
import { useAuth } from "../../context/Auth";
import LayOut from "../../components/LayOut";
import { Link } from "react-router-dom";
import axios from "axios";

const AdminDashboard = () => {
  const [auth] = useAuth();
  const [blogs, setBlogs] = useState([]);

  // Fetch blogs
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get(
          "https://portfoliomern-mxue.onrender.com/api/v1/blog/blogs"
        ); // Adjust endpoint if needed
        if (response.data.success) {
          setBlogs(response.data.blogs);
        }
      } catch (error) {
        console.error("Error fetching blogs:", error.message);
      }
    };

    fetchBlogs();
  }, []);

  return (
    <LayOut title={"Admin DashBoard"}>
      <div
        className="admin-dashboard"
        style={{ backgroundColor: "#000", color: "#fff", minHeight: "100vh" }}
      >
        <div className="container-fluid">
          <div className="row">
            {/* Sidebar */}
            <div className="col-md-3 sidebar bg-dark py-4">
              <div className="profile-section text-center mb-4">
                <div className="profile-photo-container mx-auto">
                  <img
                    src="https://media.sproutsocial.com/uploads/2022/06/profile-picture.jpeg" // Replace with actual profile photo URL
                    alt="User Profile"
                    className="profile-photo rounded-circle"
                  />
                </div>
                <div className="mt-3">
                  <h4 className="text-pink">{auth?.user?.name}</h4>
                  <p className="text-white-50">{auth?.user?.phone}</p>
                  <p className="text-white-50">{auth?.user?.email}</p>
                </div>
              </div>
            </div>

            {/* Main Content */}
            <div className="col-md-9 main-content p-4">
              <h2 className="text-light">Admin Dashboard</h2>
              <div className="actions-list mt-4">
                <ul className="list-group">
                  {/* Blog Management */}
                  <li className="list-group-item bg-dark text-light">
                    <h5>Blog Management</h5>
                    <ul>
                      <li>
                        <Link
                          to="/dashboard/admin/create-blog"
                          className="Link"
                        >
                          Create Blog
                        </Link>
                      </li>
                      {blogs.map((blog) => (
                        <li key={blog._id}>
                          <Link
                            to={`/dashboard/admin/update-blog/${blog._id}`}
                            className="Link"
                          >
                            Update Blog ({blog.name})
                          </Link>
                        </li>
                      ))}
                      <li>
                        <Link
                          to={`/dashboard/admin/delete-blog/:id`}
                          className="Link"
                        >
                          Delete Blog
                        </Link>
                      </li>
                    </ul>
                  </li>

                  {/* Project Management */}
                  <li className="list-group-item bg-dark text-light">
                    <h5>Project Management</h5>
                    <ul>
                      <li>
                        <Link
                          to="/dashboard/admin/create-project"
                          className="Link"
                        >
                          Create Project
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/dashboard/admin/update-project"
                          className="Link"
                        >
                          Update Project
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/dashboard/admin/delete-project"
                          className="Link"
                        >
                          Delete Project
                        </Link>
                      </li>
                    </ul>
                  </li>

                  {/* Client Management */}
                  <li className="list-group-item bg-dark text-light">
                    <h5>Client Management</h5>
                    <ul>
                      <li>
                        <Link
                          to="/dashboard/admin/create-client"
                          className="Link"
                        >
                          Create Client
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/dashboard/admin/update-client"
                          className="Link"
                        >
                          Update Client
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/dashboard/admin/delete-client"
                          className="Link"
                        >
                          Delete Client
                        </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayOut>
  );
};

export default AdminDashboard;
